import {  ArrayObservable  } from '/druid/ArrayObservable';

export const of = ArrayObservable.of;